angular.module('TetherApp').factory('datepickerService', [function () {

    let dateOptions = {
        formatYear: 'yy',
        startingDay: 1
    };

    let formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    let format = formats[0];

    let status = {
        opened: false
    };

    let today = function(dt) {
        return dt = new Date();
    };

    let clear = function (dt) {
        return dt = null;
    };

    let disabled = function(date, mode) {
        return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
    };

    let toggleMin = function(minDate) {
        minDate = minDate ? null : new Date();
        return minDate;
    };

    let open = function(clickEvent, status) {
        status.opened = true;
        return status;
    };

    return {
        dateOptions: dateOptions,
        formats: formats,
        format: format,
        status: status,
        today: today,
        clear: clear,
        disabled: disabled,
        toggleMin: toggleMin,
        open: open
    };

}]);
